/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath, clientSideUrl } from "../../utility/Constant";

const HomeCounter = () => {
  const { homeApi } = apiPath;
  const [homeCounterData, homeCounterLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState();
  const { clientHome } = clientSideUrl;

  useEffect(() => {
    setFilteredData(
      homeCounterData?.filter((item) => item.section_type === "counter")[0]
    );
  }, [homeCounterData]);

  if (homeCounterLoading) {
    return <Loading />;
  }

  const {
    total_countries_worked_in,
    total_registered_worker,
    total_worker_serving,
    total_companies_partnered_with,
    total_registered_worker_desc,
    total_worker_serving_desc,
    total_companies_partnered_with_desc,
    total_countries_worked_in_desc,
    section_type,
    banner_images,
    _id,
  } = filteredData ?? {};

  const imagesData = [];
  banner_images?.map((item, index) => {
    imagesData.push({
      label: `Banner Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item,
    });
  });

  const data = [
    {
      elementType: "input",
      label: "Countries worked in",
      type: "Text",
      name: "total_countries_worked_in",
      defaultValue: total_countries_worked_in,
      required: false,
    },
    {
      elementType: "input",
      label: "Registered Workers",
      type: "Text",
      name: "total_registered_worker",
      defaultValue: total_registered_worker,
      required: false,
    },
    {
      elementType: "input",
      label: "Worker Serving",
      type: "Text",
      name: "total_worker_serving",
      defaultValue: total_worker_serving,
      required: false,
    },
    {
      elementType: "input",
      label: "Companies Partnered with",
      type: "Text",
      name: "total_companies_partnered_with",
      defaultValue: total_companies_partnered_with,
      required: false,
    },
    {
      elementType: "textField",
      label: "Countries worked in description",
      type: "Text",
      name: "total_countries_worked_in_desc",
      defaultValue: total_countries_worked_in_desc,
      required: false,
    },

    {
      elementType: "textField",
      label: "Registered Workers description",
      type: "Text",
      name: "total_registered_worker_desc",
      defaultValue: total_registered_worker_desc,
      required: false,
    },

    {
      elementType: "textField",
      label: "Worker Serving description",
      type: "Text",
      name: "total_worker_serving_desc",
      defaultValue: total_worker_serving_desc,
      required: false,
    },
    {
      elementType: "textField",
      label: "Companies Partnered with description",
      type: "Text",
      name: "total_companies_partnered_with_desc",
      defaultValue: total_companies_partnered_with_desc,
      required: false,
    },
  ];

  const nestedData = [
    {
      elementType: "file",
      label: "Banner Image",
      name: "banner_images",
      multipleData: imagesData,
      multiple: false,
      fullCol: true,
      required: false,
    },
  ];

  const useData = data.concat(nestedData);

  const update = (data) => {
    if (data.banner_images) {
      let link = data.banner_images;
      data.banner_images = [
        {
          url: link,
        },
      ];
    }
    updateData(homeApi, data, _id);
    setTimeout(() => {
      window.location.reload();
    }, 800);
  };

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <Link
          className="text-black hover:text-[#DB0029]"
          to={clientHome}
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit page
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="inline w-4 h-4 ml-1 align-text-top"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
              />
            </svg>
          </span>
        </Link>
      </div>
      <div className="bg-white p-5 shadow-md rounded-md border mt-5">
        {section_type && (
          <GlobalForm data={useData} nestedData={nestedData} update={update} />
        )}
      </div>
    </div>
  );
};

export default HomeCounter;
